import { FC, MouseEvent, useState } from 'react';
import { IconButton, IconButtonProps, Menu, MenuItem } from '@mui/material';
import { Icon, IconProps } from '@iconify/react';

interface Option {
  label?: string;
  value: string;
}

export interface Props extends IconButtonProps {
  options: Option[];
  icon: string;
  onClick?: (option: Option, event: MouseEvent<HTMLElement>) => void;
  iconProps?: Omit<IconProps, 'icon'>;
}

const ButtonOptions: FC<Props> = ({ options, iconProps, icon, onClick, ...props }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  return (
    <>
      <IconButton {...props} onClick={handleMenu}>
        <Icon {...iconProps} icon={icon} />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {options.map((option, i) => (
          <MenuItem
            key={i}
            onClick={(e) => {
              handleClose();
              onClick?.(option, e);
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ButtonOptions;
